import type { Location } from 'modules/core/lib/navigation/types'

export const navigation = {
  path: 'benefits',
  children: {
    accounts: {
      size: 'full',
      path: 'accounts',
    },
    catalog: {
      size: 'full',
      path: 'catalog',
      children: {
        healthcare: {
          size: 'full',
          path: 'healthcare-management',
          children: {
            importer: { size: 'full', path: 'import-policy-holders' },
          },
        },
      },
    },
    landing: {
      size: 'full',
      path: 'landing',
    },
    usage: {
      size: 'full',
      path: 'usage',
    },
    employees: {
      size: 'full',
      path: 'employees',
    },
  },
} as const satisfies Location
